import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';


import errorslist from '@/errors';

const errors = {
	state: {
		errorCode : '',
		errorMensaje : ''
	},
	getters: {
		getErrorCode : state => state.errorCode,
		getErrorMensaje : state => state.errorMensaje,
	},
	actions: {
		eraseError : ({commit}) => {
			commit('setEraseError');	
		},
		sendInfoAboutError : ({commit,getters},id) => {

			if(location.hostname != 'localhost'){

				var time = new Date()

				let data;
				data = '----------------------------------------\n';
				data += 'ERROR EN EL FRONT\n';
				data += 'URL del error:\n'+location.href+'\n';
				data += 'Código de error:\n'+id+'\n';
				data += 'Nombre del usuario:\n'+getters.getUserName+'\n';
				data += 'Hora del error:\n'+time.toTimeString()+'\n';
				data += 'Mensaje de error:\n';
				data += (!!errorslist[id]) ? errorslist[id].es.cuerpo+'\n' : 'Error Desconocido\n';
				data += '----------------------------------------';

				data = {"text" : data};

				let url = 'https://hooks.slack.com/services/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';

				var xhr = new XMLHttpRequest();

				xhr.open("POST", url, true);

				xhr.send(JSON.stringify(data));

			}

		},
		sendErrorServer : ({},error)=>{

			if(location.hostname != 'localhost'){

				var time = new Date()

				let data;
				data = '----------------------------------------\n';
				data += 'ERROR EN EL SERVICIO\n';
				data += 'Hora del error:\n'+time.toTimeString()+'\n';
				data += 'Mensaje:\n'+error.data.Message+'\n';
				data += 'Detalle:\n'+error.data.MessageDetail+'\n';
				data += '----------------------------------------';

				data = {"text" : data};

				let url = 'https://hooks.slack.com/services/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';

				var xhr = new XMLHttpRequest();
				xhr.open("POST", url, true);
				xhr.send(JSON.stringify(data));
			}
		}
	},
	mutations: {
		setEraseError : function(state){
			state.errorCode = '';
			state.errorMensaje = '';
		},
		setError : function(state, error){
			state.errorCode = error;
			state.errorMensaje = '';
		},
		setErrorMensaje : function(state, mensaje){
			state.errorMensaje = mensaje;
		}
	}
}



export default errors;



// WEBPACK FOOTER //
// ./src/store/errors.js